export const resolveSafeReturnPath = (returnTo) => {
  const path = String(returnTo || "").trim();
  if (path.startsWith("/") && !path.startsWith("//")) {
    return path;
  }
  return "";
};

export const resolveDefaultHomePath = (user) => {
  const aiHiringOnly = Boolean(user?.aiHiringOnly);
  const featureAccess = Array.isArray(user?.featureAccess)
    ? user.featureAccess.filter(Boolean)
    : [];
  if (aiHiringOnly) return "/ai-hiring";
  if (featureAccess.includes("agent247")) return "/agent247";
  if (featureAccess.includes("ai_hiring")) return "/ai-hiring";
  if (featureAccess.length === 0) return "/care-dashboard";
  return "/";
};

export const resolvePostLoginPath = (user, returnTo) =>
  resolveSafeReturnPath(returnTo) || resolveDefaultHomePath(user);
